import React, { memo } from 'react';

const CellComponent = memo(
    ({ columnIndex, rowIndex, style, ariaAttributes, data, renderRow, columnCount }) => {
        const index = rowIndex * columnCount + columnIndex;

        if (!data || index >= data.length) return null;

        return (
            <div style={style} {...ariaAttributes}>
                {renderRow({ index, data: data[index] })}
            </div>
        );
    },
);

export default CellComponent;
